import type { SVGProps } from 'react';

const iconProps = {
  width: '1em',
  height: '1em',
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.25,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} satisfies SVGProps<SVGSVGElement>;

export function IntegrationGridIcon({
  topRight,
  ...svgProps
}: {
  topRight: 'filled' | 'play' | 'plus';
} & SVGProps<SVGSVGElement>) {
  return (
    <svg {...iconProps} {...svgProps}>
      <rect x="3.5" y="3.5" width="7.5" height="7.5" rx="1.5" />
      <rect x="3.5" y="13" width="7.5" height="7.5" rx="1.5" />
      <rect x="13" y="13" width="7.5" height="7.5" rx="1.5" />
      {topRight === 'filled' ? (
        <rect
          x="12.375"
          y="2.875"
          width="8.75"
          height="8.75"
          rx="2.125"
          fill="currentColor"
          stroke="none"
        />
      ) : topRight === 'plus' ? (
        <path d="M13 7.25h7.5M16.75 3.5V11" />
      ) : (
        <path
          fill="currentColor"
          fillRule="evenodd"
          stroke="currentColor"
          strokeWidth={0.8}
          d="m10.104 5.01 6.339 3.566c.782.44 1.415.796 1.883 1.119.47.324.88.684 1.102 1.175a2.75 2.75 0 0 1 0 2.26c-.222.491-.633.851-1.102 1.175-.468.323-1.1.679-1.883 1.119l-6.34 3.566c-.755.425-1.368.77-1.872.995-.508.227-1.015.387-1.54.328a2.75 2.75 0 0 1-1.921-1.124c-.31-.428-.419-.949-.47-1.503-.05-.55-.05-1.252-.05-2.12V8.435c0-.867 0-1.57.05-2.12.051-.554.16-1.075.47-1.503A2.75 2.75 0 0 1 6.69 3.687c.525-.06 1.032.1 1.54.328.504.226 1.117.57 1.873.995m-2.485.374c-.437-.195-.642-.22-.76-.206a1.25 1.25 0 0 0-.873.51c-.069.096-.148.287-.192.763-.043.473-.044 1.106-.044 2.02v7.057c0 .915 0 1.548.044 2.021.044.476.123.667.192.763.206.285.524.47.874.51.117.014.322-.01.759-.206.433-.194.985-.504 1.782-.952l6.273-3.529c.824-.463 1.396-.785 1.8-1.064.408-.282.538-.45.586-.557a1.25 1.25 0 0 0 0-1.027c-.048-.108-.178-.276-.586-.558-.404-.278-.976-.601-1.8-1.064L9.401 6.336c-.797-.448-1.35-.758-1.782-.952"
          clipRule="evenodd"
          transform="translate(10.308 1.225) scale(0.53681 0.50212)"
        />
      )}
    </svg>
  );
}
